import { axios } from '@Root/API'

export const remove = (studyProgrammeId, moduleInstanceId ) => {
	return axios.delete(`course-session/${studyProgrammeId}/module-instances/${moduleInstanceId}`)
}
